import {useAuth} from '@app/modules/auth'

import useIsMobileIOSCookieTrue from './useIsMobileIOSCookieTrue'

const useIsPremium = () => {
  const forcePremium = useIsMobileIOSCookieTrue()

  const isPremium = useAuth().currentUser?.is_premium || forcePremium // временно

  return isPremium
}

export default useIsPremium
